import * as React from 'react';

function AutoSkipContentIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M12.6833 5.46429C13.5816 6.01579 14.4248 6.88108 15.1016 8.20093L12.6302 8.20093C12.0779 8.20093 11.6302 8.64864 11.6302 9.20093C11.6302 9.75321 12.0779 10.2009 12.6302 10.2009L17.6302 10.2009C18.1825 10.2009 18.6302 9.75321 18.6302 9.20093V4.20093C18.6302 3.64865 18.1825 3.20093 17.6302 3.20093C17.0779 3.20093 16.6302 3.64864 16.6302 4.20093V6.82645C15.8397 5.45259 14.8494 4.44729 13.7297 3.75987C12.347 2.91098 10.8271 2.58337 9.3593 2.58337C5.03761 2.58337 1.53418 6.0868 1.53418 10.4085C1.53418 10.9608 1.98189 11.4085 2.53418 11.4085C3.08646 11.4085 3.53418 10.9608 3.53418 10.4085C3.53418 7.19137 6.14218 4.58337 9.3593 4.58337C10.5307 4.58337 11.6723 4.8436 12.6833 5.46429Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M10.1305 15.8676C11.051 15.8676 11.7972 15.1214 11.7972 14.201C11.7972 13.2805 11.051 12.5343 10.1305 12.5343C9.21005 12.5343 8.46386 13.2805 8.46386 14.201C8.46386 15.1214 9.21005 15.8676 10.1305 15.8676Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M4.87011 14.3341C4.87011 15.2546 4.12391 16.0008 3.20344 16.0008C2.28297 16.0008 1.53677 15.2546 1.53677 14.3341C1.53677 13.4137 2.28297 12.6675 3.20344 12.6675C4.12391 12.6675 4.87011 13.4137 4.87011 14.3341Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M16.7972 16.0008C17.7177 16.0008 18.4639 15.2546 18.4639 14.3341C18.4639 13.4137 17.7177 12.6675 16.7972 12.6675C15.8767 12.6675 15.1305 13.4137 15.1305 14.3341C15.1305 15.2546 15.8767 16.0008 16.7972 16.0008Z"
        className="fill-icn-txt-prim"
      />
    </svg>
  );
}

export default AutoSkipContentIcon;
